// Panels
export const FILTER_PANEL = 'FILTER_PANEL';
export const OBJECT_BUILDER_PANEL = 'OBJECT_BUILDER_PANEL';
export const EDIT_CARDS_PANEL = 'EDIT_CARDS_PANEL';
export const LEGACY_OBJECT_BUILDER_PANEL = 'LEGACY_OBJECT_BUILDER_PANEL';
export const PRODUCT_CREATE_PANEL = 'PRODUCT_CREATE_PANEL';
export const CONDITIONAL_PROPERTIES_PANEL = 'CONDITIONAL_PROPERTIES_PANEL';
export const COLUMN_INSIGHTS_PANEL = 'COLUMN_INSIGHTS_PANEL';